module.exports = __webpack_public_path__ + "img/empty.7b1ba83c.png";